import { AType, summon } from "@silversea-ssc/functional-support"
import { Branded, Int } from "io-ts"
import * as F from "fp-ts/function"
import * as E from "fp-ts/Either"
import { PathReporter } from "io-ts/PathReporter"

export interface NonNegativeIntBrand {
    readonly NonNegativeInt: unique symbol
}

export const NonNegativeInt = summon((F) =>
    F.refined(
        F.number(),
        (x: number): x is Branded<number, NonNegativeIntBrand> => Int.is(x) && x >= 0,
        "NonNegativeInt",
        {
            IoTsURI: (_x, { withMessage }) => withMessage(_x, (x) => `${x} is not a non-negative integer`),
            FastCheckURI: (_x, { fastCheck }) =>
                fastCheck.integer({ min: 0 }).map((x: number) => x as Branded<number, NonNegativeIntBrand>),
        },
    ),
)
export type NonNegativeInt = AType<typeof NonNegativeInt>

export const buildUnsafe = (value: number): NonNegativeInt =>
    F.pipe(
        NonNegativeInt.strictType.decode(value),
        E.getOrElse((e): NonNegativeInt => {
            throw new Error(`Tried to unsafely build a non negative int: ${PathReporter.report(E.left(e))}`)
        }),
    )
export const round = F.flow(Math.round, NonNegativeInt.strictType.decode)
export const strictType = NonNegativeInt.strictType
